module.exports = __webpack_public_path__ + "static/media/Sponsorbay.0a466f8b.png";